import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ZenAIQueryRequest, ZenAIStreamEvent } from 'src/app/models/api/zenAi.model';
import { HttpStreamService } from '../http/http-stream.service';

@Injectable({
  providedIn: 'root',
})
export class ZenAiHttpService {
  private readonly _zenAiEndpoint = 'zen-ai';

  constructor(private readonly _httpStreamService: HttpStreamService) {}

  public query(request: ZenAIQueryRequest): Observable<ZenAIStreamEvent> {
    return this._httpStreamService.postStream<ZenAIQueryRequest, ZenAIStreamEvent>(
      `${this._zenAiEndpoint}/query-stream`,
      request,
      undefined, // headers
      true // beta - Use beta API version (v1-beta)
    );
  }
}
